import React, { useState, useEffect } from "react"
import { moveFocusTo } from "../../../utils/elements";
import * as Constants from "../../../utils/constants"
import {
  Container,
  Input,
  Row,
  Col,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Alert
} from 'design-react-kit';

export const SibaMostraAlternative = ({ codiceFiscale, targa, handleChoice, handleBack }) => {

  const [isModaleVisibile, setModaleVisibile] = useState(true);
  const [localChoice, setLocalChoice] = useState('');

  useEffect(() => {
    moveFocusTo("conferma_localChoice");
  });

  const onSubmit = () => handleChoice(localChoice);
  const onValueChange = (event) => { setLocalChoice(event.target.value); }
  const handleClose = () => setModaleVisibile(false)


  let idLabelQuadricicloLeggero = Constants.RADIO_LABEL_QUADRICICLO_LEGGERO.replaceAll(" ","");
  let idLabelProvaAuto = Constants.RADIO_LABEL_TARGA_PROVA_AUTO.replaceAll(" ","");
  let idLabelProvaMoto = Constants.RADIO_LABEL_TARGA_PROVA_MOTO.replaceAll(" ","");
  let idLabelProvaCiclo = Constants.RADIO_LABEL_TARGA_PROVA_CICLO.replaceAll(" ","");
  let idLabelProvaRimorchio = Constants.RADIO_LABEL_TARGA_PROVA_RIMORCHIO.replaceAll(" ","");
  let idLabelAltriCasi = Constants.RADIO_LABEL_ALTRI_CASI.replaceAll(" ","");
 
  let ariaLabelCicloMotore = Constants.RADIO_LABEL_CICLOMOTORE + "Description";
  let ariaLabelQuadricicloLeggero = idLabelQuadricicloLeggero + "Description";
  let ariaLabelProvaAuto = idLabelProvaAuto + "Description";
  let ariaLabelProvaMoto = idLabelProvaMoto + "Description";
  let ariaLabelProvaCiclo = idLabelProvaCiclo + "Description";
  let ariaLabelProvaRimorchio = idLabelProvaRimorchio + "Description";
  let ariaLabelAltriCasi = idLabelAltriCasi + "Description";

  //START RENDERING
  return (
    <Container className="px-2 my-2" id="mostraAlternative" tag="section" >
      <Modal isOpen={isModaleVisibile} popConfirm style={{ maxWidth: "50%" }}>
        <ModalHeader charCode={215} closeAriaLabel="Close" tag="h5" wrapTag="div" >
          ATTENZIONE
        </ModalHeader>
        <ModalBody tag="div">
          Ricontrolla i dati inseriti:<br />
          C.F. <strong>{codiceFiscale}</strong> <br />
          Targa: <strong>{targa}</strong> <br />
          Sono corretti?
        </ModalBody>
        <ModalFooter tag="div">
          <Button className="btn btn-outline-primary" onClick={handleBack} >
            NO
          </Button>
          <Button className="btn btn-primary" color="primary" onClick={handleClose} >
            SI
          </Button>
        </ModalFooter>
      </Modal>
      {!isModaleVisibile ?
        <Container className="px-2 my-2" id="mostraAlternative2" tag="section" >
          <Alert color="warning">ATTENZIONE: non utilizzare questa pagina per pagare il bollo di AUTOVEICOLI o MOTOVEICOLI</Alert>
        </Container> : React.Fragment
      }
      <Container className="px-2 my-2 siba-align-left d-flex justify-content-around" id="mostraAlternative3" tag="section" >
        <Row>
          <Col>
            <h4>Specificare la categoria di: {targa}</h4>
            <br />
            <div className="form-check my-2">
              <Input
                id={Constants.RADIO_LABEL_CICLOMOTORE}
                value={Constants.TIPO_VEICOLO_CICLOMOTORE}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_CICLOMOTORE} />
              <Label for={Constants.RADIO_LABEL_CICLOMOTORE} tag="label" id={ariaLabelCicloMotore}>
                Ciclomotore
              </Label>
            </div>
            <div className="form-check my-2">
              <Input
                id={idLabelQuadricicloLeggero}
                value={Constants.TIPO_VEICOLO_QUADRICICLO_LEGGERO}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_QUADRICICLO_LEGGERO} />
              <Label for={idLabelQuadricicloLeggero} tag="label" id={ariaLabelQuadricicloLeggero}>
                Quadriciclo leggero
              </Label>
            </div>
            <div className="form-check my-2">
              <Input
                id={idLabelProvaAuto}
                value={Constants.TIPO_VEICOLO_TARGA_PROVA_AUTO}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_TARGA_PROVA_AUTO} />
              <Label for={idLabelProvaAuto} tag="label" id={ariaLabelProvaAuto}>
                Targa prova autoveicolo
              </Label>
            </div>
            <div className="form-check my-2">
              <Input
                id={idLabelProvaMoto}
                value={Constants.TIPO_VEICOLO_TARGA_PROVA_MOTO}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_TARGA_PROVA_MOTO} />
              <Label for={idLabelProvaMoto} tag="label" id={ariaLabelProvaMoto}>
                Targa prova motoveicolo
              </Label>
            </div>
            <div className="form-check my-2">
              <Input
                id={idLabelProvaCiclo}
                value={Constants.TIPO_VEICOLO_TARGA_PROVA_CICLO}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_TARGA_PROVA_CICLO} />
              <Label for={idLabelProvaCiclo} tag="label" id={ariaLabelProvaCiclo}>
                Targa prova ciclomotore
              </Label>
            </div>
            <div className="form-check my-2">
              <Input
                id={idLabelProvaRimorchio}
                value={Constants.TIPO_VEICOLO_TARGA_PROVA_RIMORCHIO}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_TARGA_PROVA_RIMORCHIO} />
              <Label for={idLabelProvaRimorchio} tag="label" id={ariaLabelProvaRimorchio}>
                Targa prova rimorchio
              </Label>
            </div>
            <div className="form-check my-2" >
              <Input
                id={idLabelAltriCasi}
                value={Constants.TIPO_VEICOLO_ALTRI_CASI}
                bsSize="sm"
                type="radio"
                name="gruppo_alternative"
                onChange={onValueChange}
                defaultChecked={localChoice === Constants.RADIO_LABEL_ALTRI_CASI} />
              <Label for={idLabelAltriCasi} tag="label" id={ariaLabelAltriCasi}>
                Altre categorie (Reimm. veicoli storici, targhe EE, AFI, CRISI/FALLIMENTO...)
              </Label>
            </div>
          </Col>
        </Row>
      </Container>
      <Button id="conferma_localChoice" className="btn btn-primary" color="primary" size="sm" icon={false} tag="button" onClick={onSubmit} disabled={!localChoice}>
        Conferma
      </Button>
    </Container>
  )
}

export default SibaMostraAlternative;